import PropTypes from 'prop-types'
import React from 'react'
import { Heading, Text } from '@plurall/elo'

import styles from './ErrorMessage.module.scss'

const ErrorMessage = ({ src, subTitle, title }) => (
  <div className={styles['no-results']}>
    <img src={src} alt='Sem resultados' />

    <div className={styles['title-wrapper']}>
      <Heading size='normal'>{title}</Heading>
    </div>

    {subTitle && <Text>{subTitle}</Text>}
  </div>
)

ErrorMessage.defaultProps = {
  src: `${process.env.REACT_APP_ASSETS_URL}/static/assets/images/tired.svg`,
  title: 'Corremos e voamos, mas não encontramos o que você busca.',
}

ErrorMessage.propTypes = {
  src: PropTypes.string,
  subTitle: PropTypes.string,
  title: PropTypes.string,
}

export default ErrorMessage
